import { i18n } from '@/to-fsd/shared/lib/i18n';

const helper = data => {
  if (!data) {
    return i18n.global.t('shared.api.unknownError');
  }

  if (data.message) {
    return data.message;
  }

  if (data.detail) {
    return data.detail;
  }

  if (data.title) {
    return data.title;
  }

  if (data.error) {
    return data.error;
  }

  return i18n.global.t('shared.api.unknownError');
};

export const extractErrorMessage = async error => {
  if (typeof error === 'string') {
    return error;
  }

  const isNetworkError = !error.response;

  if (isNetworkError) {
    return '[Network] ' + i18n.global.t('shared.api.unknownError');
  }
  if (typeof error.response.data === 'string') {
    return error.response.data;
  }
  if (error.response.data instanceof Blob) {
    const text = await error.response.data.text();
    const data = JSON.parse(text);
    return helper(data);
  }
  return helper(error.response.data);
};
